var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145 482H30V367H0v145h145zM482 367v115H367v30h145V367zM30 145V30h115V0H0v145zM367 0v30h115v115h30V0zM122.293 171.934c-28.292 0-51.31 23.018-51.31 51.31v65.35c0 28.292 23.018 51.31 51.31 51.31 28.293 0 51.311-23.018 51.311-51.31v-65.35c0-28.293-23.018-51.31-51.311-51.31zm21.311 116.659c0 11.75-9.559 21.31-21.311 21.31-11.75 0-21.31-9.56-21.31-21.31v-65.35c0-11.75 9.56-21.31 21.31-21.31 11.751 0 21.311 9.56 21.311 21.31zM255.452 201.934c11.75 0 21.309 9.56 21.309 21.31h30c0-28.292-23.018-51.31-51.309-51.31-28.292 0-51.31 23.018-51.31 51.31v65.35c0 28.292 23.018 51.31 51.31 51.31s51.309-23.018 51.309-51.31h-30c0 11.75-9.559 21.31-21.309 21.31s-21.31-9.56-21.31-21.31v-65.35c.001-11.751 9.56-21.31 21.31-21.31zM418.245 265.298c14.382-9.099 23.902-24.751 23.902-42.508 0-28.042-23.725-50.857-52.886-50.857h-51.663v167.969h30v-66.256h21.663c.052 0 .103-.004.154-.004l21.368 66.423h31.514zm-50.647-63.364h21.663c12.405 0 22.886 9.551 22.886 20.857 0 11.305-10.481 20.857-22.886 20.857h-21.663z",
    fill: "#0058ff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcr);
export default __webpack_public_path__ + "static/media/ocr.125d789334b046af3d670c7dd2a82bc2.svg";
export { ForwardRef as ReactComponent };